import React from 'react';
import { withRouter } from 'react-router-dom';
import { Grid } from '@material-ui/core';

import ButtonStyledLink from '../../ux/ButtonStyledLink';

class Settings extends React.Component {

  componentDidMount() {}

  render() {
    return (
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        style={{ marginTop: 15, width: '92vw', 'padding-left': '25px' }}
      >
        <div className="inf-hero" style={{ width: '100%' }}>
          <div className="inf-hero-inner">
            <p className="inf-hero-kicker">Account</p>
            <h1 className="inf-hero-title">Account Settings</h1>
            <p className="inf-hero-sub">
              Manage your profile, security and connected accounts.
            </p>
          </div>
        </div>
        <Grid
          item
          md={12}
          style={{
            backgroundColor: 'white',
            width: '100%',
            border: '1px solid #DCDCDC',
            'border-radius': '5px',
            marginBottom: 10,
          }}
        >
          <ButtonStyledLink to={'/influencer/personal-settings'} label={'Personal Information'} />
        </Grid>
        <Grid
          item
          md={12}
          style={{
            backgroundColor: 'white',
            width: '100%',
            border: '1px solid #DCDCDC',
            'border-radius': '5px',
            marginBottom: 10,
          }}
        >
          <ButtonStyledLink to={'/influencer/security-settings'} label={'Security Settings'} />
        </Grid>
        <Grid
          item
          md={12}
          style={{
            backgroundColor: 'white',
            width: '100%',
            border: '1px solid #DCDCDC',
            'border-radius': '5px',
            marginBottom: 10,
          }}
        >
          <ButtonStyledLink to={'/influencer/social-settings'} label={'Social Accounts'} />
        </Grid>
        <Grid
          item
          md={12}
          style={{
            backgroundColor: 'white',
            width: '100%',
            border: '1px solid #DCDCDC',
            'border-radius': '5px',
            marginBottom: 10,
          }}
        >
          <ButtonStyledLink to={'/influencer/about-me'} label={'About Me'} />
        </Grid>
      </Grid>
    );
  }
}

export default withRouter(Settings);
